// extracted by mini-css-extract-plugin
module.exports = {"pic_box":"pic_box-19sb6gIO","pic":"pic-ebTirHxN","trans":"trans-2g4intEE","list":"list-2Kxa0hM5"};